import Schedules from '@/app/professional/schedulings/preview/schedules'
import StepAlertNextStep from '../../components/alert-next-step'
import Preview from '../../components/preview/preview'
export default {
  Schedules,
  Preview,
  StepAlertNextStep
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/rules/form/resources/components.js